import { ChangeEvent, useState } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { Button, ButtonVariants } from '../../Atoms/Button';
import PartnerPageDataService from '../../partner-pages/services/partner-pages.service';
import { Heading, HeadingType } from '../../Typography';

const BlackBanner = (): JSX.Element => {
  const [inputVal, setInputVal] = useState<string>('');
  const [showSuccessMsg, setShowSuccessMsg] = useState<boolean>(false);
  const [recaptchaVal, setRecaptchaVal] = useState<string | null>(null);

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const value = parseInt(e.target.value) || '';
    setInputVal(value.toString());
  };
  const handleChangeCaptcha = (e: string | null) => {
    setRecaptchaVal(e);
  };

  const sendBlackSMS = () => {
    PartnerPageDataService.sendBlackDownloadLink(inputVal)
      .then(() => {
        setShowSuccessMsg(true);
      })
      .catch((e: Error) => {
        console.log(e);
      });
  };

  const validateAndSubmit = () => {
    if (!inputVal || inputVal.length !== 10) {
      alert('Please enter a valid phone number');
      return;
    }
    if (!recaptchaVal) {
      alert('Captcha is required');
      return;
    }
    if (recaptchaVal && inputVal) {
      sendBlackSMS();
    }
  };
  return (
    <div className="w-full relative bg-[#23282e]">
      <div className="wg-container flex flex-wrap py-12 items-center">
        <div className="w-1/2 sm:w-full">
          <Heading
            content="Now you can File your ITR on the go with the Black app by Cleartax!"
            variant={HeadingType.h3}
            className="text-s-32 sm:text-s-24 text-white"
          />

          {!showSuccessMsg ? (
            <>
              {' '}
              <div className="py-6 pr-12">
                <input
                  className="border rounded-lg border-slate-600 focus:outline-none px-4 py-2 w-full bg-transparent text-white"
                  type="text"
                  required
                  value={inputVal}
                  minLength={10}
                  maxLength={10}
                  placeholder="Enter your phone number"
                  onChange={handleChange}
                  data-testid="phonenumber-input"
                />
              </div>
              <div className="flex flex-wrap items-center">
                <ReCAPTCHA
                  sitekey="6LevgAErAAAAAKzR-MPcdXwti7lpxV3-jOPM0vL2"
                  onChange={handleChangeCaptcha}
                  data-testid="phone-recaptcha"
                />
                <Button
                  variant={ButtonVariants.bluefilled}
                  className="ml-6 text-base rounded-md"
                  type="submit"
                  onClick={validateAndSubmit}
                >
                  Get Download Link
                </Button>
              </div>
            </>
          ) : (
            <div className="text-white py-6 font-bold text-s-20">
              Download link is sent!!
            </div>
          )}
        </div>
        <div className="w-1/2 sm:w-full">
          <img
            src="https://assets1.cleartax-cdn.com/cleartax/images/1658776005_612f0ce998dbee71d755ddcc_appmockups.png"
            alt="black"
          />
        </div>
      </div>

      <img
        className="absolute right-12 top-12"
        src="https://assets1.cleartax-cdn.com/cleartax/images/1658868729_612f0e52859b976781f6bd5e_blacklogo.png"
        alt="black"
        width="95"
        height="65"
      />
    </div>
  );
};

export { BlackBanner };
